import Form from './Form/Form'
import { styleFormBlock } from './styleFormBlock'
import { useFormBlock } from './useFormBlock'

const FormBlock = () => {
    const { width } = useFormBlock()

    const LeftPart = (
        <LeftWrapperSC>
            <TitleSC $color="#FFFFFF" $marginBottomPX={'30px'}>
                Упрощаем жизнь
            </TitleSC>
            <DescrSC>
                Получите возможность испытать новый подход в работе с данными{' '}
                <FreeSC>бесплатно</FreeSC>.
            </DescrSC>
            <QuoteWrapperSC>
                <QuoteTextSC>
                    "Теперь вам не нужно использовать Excel, записывать формулы
                    или искать нужные данные, достаточно написать нужный
                    вопрос."
                </QuoteTextSC>
                <QuoteAuthorWrapperSC>
                    <QuoteAuthorImgSC src="/CEOPhoto.webp" alt="CEO Photo" />
                    <QuoteRightBlockSC>
                        <QuoteNameSC>Антон Аверьянов</QuoteNameSC>
                        <QuoteAuthorPost>CEO</QuoteAuthorPost>
                    </QuoteRightBlockSC>
                </QuoteAuthorWrapperSC>
            </QuoteWrapperSC>
        </LeftWrapperSC>
    )

    return (
        <FormBlockSC>
            <CustomContainerSC>
                <FormWrapperSC>
                    {width > 870 && LeftPart}
                    <Form />
                </FormWrapperSC>
            </CustomContainerSC>
        </FormBlockSC>
    )
}

const {
    FreeSC,
    DescrSC,
    TitleSC,
    QuoteTextSC,
    FormBlockSC,
    QuoteNameSC,
    FormWrapperSC,
    LeftWrapperSC,
    QuoteWrapperSC,
    QuoteAuthorPost,
    QuoteAuthorImgSC,
    QuoteRightBlockSC,
    CustomContainerSC,

    QuoteAuthorWrapperSC,
} = styleFormBlock()

export default FormBlock
